<template>
  <hic-table :entities="entities" :condition="myCondition" @load="page" :loading="loading">
    <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column label="床位号" align="left" prop="bedNo" sortable="custom" width="100" key="bedNo"></el-table-column>
    <el-table-column label="姓名" prop="patientName" align="left">
      <template slot-scope="{ row }">
        <span class="sub-title">{{ row.patientName }}</span>
      </template>
    </el-table-column>


    <el-table-column label="预交总额" align="right" prop="deposit">
      <template #default="{ row }">
        {{ row.deposit | fmtFloat }}
      </template>
    </el-table-column>
    <el-table-column label="记账金额" align="right" prop="amount">
      <template #default="{ row }">
        {{ row.amount | fmtFloat }}
      </template>
    </el-table-column>
    <el-table-column label="余额" align="right" prop="balance">
      <template #default="{ row }">
        <span v-if="row.deposit <= row.amount" class="danger">{{ ((row.deposit || 0) - row.amount) | fmtFloat }}</span>
        <span v-else class="success">{{ ((row.deposit || 0) - row.amount) | fmtFloat }}</span>
      </template>
    </el-table-column>
    <el-table-column label="费用类别" align="center" prop="ipType" width="100"> </el-table-column>
    <el-table-column label="当前科室" align="right" prop="deptCode">
      <template slot-scope="{ row }">
        {{ row.deptCode | dictText("Dept") }}
      </template>
    </el-table-column>
    <el-table-column label="当前病区" align="right" prop="originalWardCode">
      <template slot-scope="{ row }">
        {{ row.wardCode | dictText("IpWard") }}
      </template>
    </el-table-column>
    <el-table-column label="住院诊断" align="left" prop="diagnosisName" show-overflow-tooltip> </el-table-column>
    <el-table-column label="在院天数" align="right" prop="startDate">
      <template slot-scope="{ row }">
        {{ $utils.Dt.span(row.startDate, $utils.Dt.now(), "d") }}
      </template>
    </el-table-column>
    <el-table-column label="入院日期" align="center" prop="startDate">
      <template slot-scope="{ row }">
        {{ row.startDate | fmtDate }}
      </template>
    </el-table-column>
  </hic-table>
</template>

<script>
  import api from "./api";
  export default {
    props: {
      condition: Object,
    },
    data() {
      return {
        loading: false,
        myCondition: {
          pageIndexOnView: 1,
          pageSize: 20,
          keyword: null,
          ipNo: null,
        },
        entities: {},
      };
    },
    watch: {
      condition() {
        this.page();
      },
    },
    mounted() {
      this.page();
    },
    methods: {
      page() {
        this.myCondition.deptCode = this.condition.deptCode;
        this.myCondition.state = "已入住";
        this.myCondition.isRunOut = true;
        this.myCondition.keyword = this.condition.keyword;
        if (this.condition.patient) {
          this.myCondition.ipNo = this.condition.patient.ipNo;
        } else {
          this.myCondition.ipNo = null;
        }
        this.loading = true;
        api.Hospitalization.query(this.myCondition)
          .then((res) => {
            this.entities = res;
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
